import { render, staticRenderFns } from "./field-array.vue?vue&type=template&id=3a372e75&"
import script from "./field-array.vue?vue&type=script&lang=js&"
export * from "./field-array.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports